import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Button, Capitalize, H4, H5 } from '../../../../../components';

import { questionShape } from '../../../../../propsShape';

const AssetAnswerHeaderContainer = styled.div`
  display: flex;
  align-items: 'center';
  justify-content: 'space-between';
`;

const AssetTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const AssetAnswerHeader = ({ currentQuestion, onOpenAssetsModal }) => (
  <AssetAnswerHeaderContainer>
    <AssetTitleContainer>
      {currentQuestion.assetTitle && (
        <H5 color='var(--content-subtitle)'>{currentQuestion.assetTitle}</H5>
      )}
      <H4 color='var(--content-body)'>
        <Capitalize string={currentQuestion.body} />
      </H4>
    </AssetTitleContainer>
    {/* Do not show save button if answer is canned */}
    {!currentQuestion.answer.isCanned && (
      <Button naked onClick={onOpenAssetsModal}>
        {currentQuestion.spaceIds.length > 0 ? 'Unsave' : 'Save'}
      </Button>
    )}
  </AssetAnswerHeaderContainer>
);

AssetAnswerHeader.propTypes = {
  currentQuestion: questionShape.isRequired,
  onOpenAssetsModal: PropTypes.func.isRequired
};

export { AssetAnswerHeader };
